export const MuiAlert = {
  styleOverrides: {
    root: {
      backgroundColor: "var(--color-red)",
      borderRadius: "0",
      fontWeight: "bold",
      fontSize: "1rem",
      color: "white",
    },
  },
};
